module.exports = __webpack_public_path__ + "static/media/spell-check.a117e62f.svg";